module.exports = __webpack_public_path__ + "img/button_open.7ed35a49.svg";